export { FgEventType } from './types.js';

function createFgEventBus() {
  return { _listeners: /* @__PURE__ */ new Map(), _dispatchStack: [], _queue: [] };
}
function queueFgEvent(bus, channel, payload) {
  bus._queue.push({ channel, payload });
}
function flushFgEvents(bus) {
  const queued = bus._queue.splice(0, bus._queue.length);
  for (const event of queued) {
    pumpFgEvent(bus, event.channel, event.payload);
  }
}
function subscribeFgEvent(bus, channel, handler, owner = bus) {
  let subscriptions = bus._listeners.get(channel);
  if (!subscriptions) {
    subscriptions = [];
    bus._listeners.set(channel, subscriptions);
  }
  const subscription = { handler, owner };
  subscriptions.push(subscription);
  return () => {
    const list = bus._listeners.get(channel);
    if (!list) {
      return;
    }
    const i = list.indexOf(subscription);
    if (i >= 0) {
      list.splice(i, 1);
    }
  };
}
function pumpFgEvent(bus, channel, payload) {
  const subscriptions = bus._listeners.get(channel);
  if (!subscriptions || subscriptions.length === 0) {
    return;
  }
  const reference = typeof payload.event === "string" ? payload.event : `/extensions/KHR_interactivity/events/${String(payload.eventName ?? channel)}`;
  const handlersByOwner = /* @__PURE__ */ new Map();
  for (const { handler, owner } of subscriptions.slice()) {
    const handlers = handlersByOwner.get(owner);
    if (handlers) {
      handlers.push(handler);
    } else {
      handlersByOwner.set(owner, [handler]);
    }
  }
  for (const handlers of handlersByOwner.values()) {
    pumpFgEventHandlers(bus, handlers, { ...payload, event: reference });
  }
}
function pumpFgEventHandlers(bus, handlers, payload) {
  const reference = typeof payload.event === "string" ? payload.event : `/extensions/KHR_interactivity/events/${String(payload.eventName ?? "")}`;
  const dispatch = { reference, stopImmediate: false, stopTransitive: false, allowTransitive: 0 };
  bus._dispatchStack.push(dispatch);
  try {
    const eventPayload = { ...payload, event: reference };
    for (const handler of handlers) {
      handler(eventPayload);
      if (dispatch.stopImmediate) {
        break;
      }
      dispatch.stopTransitive = false;
    }
  } finally {
    bus._dispatchStack.pop();
  }
}
function stopFgEventPropagation(bus, reference, stopImmediate) {
  for (let i = bus._dispatchStack.length - 1; i >= 0; i--) {
    const dispatch = bus._dispatchStack[i];
    if (dispatch.reference === reference) {
      dispatch.stopTransitive = true;
      dispatch.stopImmediate ||= stopImmediate;
      return;
    }
  }
}
function isFgEventTransitivePropagationStopped(bus) {
  const dispatch = bus._dispatchStack[bus._dispatchStack.length - 1];
  return dispatch ? dispatch.stopTransitive && dispatch.allowTransitive === 0 : false;
}
function allowFgEventPropagation(bus, callback) {
  const dispatch = bus._dispatchStack[bus._dispatchStack.length - 1];
  if (!dispatch) {
    callback();
    return;
  }
  dispatch.allowTransitive++;
  try {
    callback();
  } finally {
    dispatch.allowTransitive--;
  }
}
function clearFgEventBus(bus) {
  bus._listeners.clear();
  bus._queue.length = 0;
  bus._dispatchStack.length = 0;
}

export { allowFgEventPropagation, clearFgEventBus, createFgEventBus, flushFgEvents, isFgEventTransitivePropagationStopped, pumpFgEvent, pumpFgEventHandlers, queueFgEvent, stopFgEventPropagation, subscribeFgEvent };
//# sourceMappingURL=event-bus.js.map
